<template lang="pug">
.product-info(v-if="product")
  h1.product-info__title.h3(v-if="product.title" v-html="product.title")
  div.product-info__price
    //- span.h4.product-info__price--sale(v-if="price" v-html="price")
    //- span.h4.product-info__price--compare(v-if="comparePrice") {{comparePrice}}
    span.h6.product-info__variant-title(v-if="variantTitle !== 'Default Title'" v-text="variantTitle")
    //- span.space
    .bv-inline-ratings-widget(data-bv-show="rating_summary" :data-bv-product-id="product.id" )
  p.product-info__excerpt.body--md(v-if="product.description" v-html="product.description")
  a.product-info__nutrition-link.link.link--primary(
    v-if="nutritionFactsVisible"
    @click.prevent.stop="scrollToNutritionFacts"
    href="#nutritionFactsH2"
    tabindex="0"
  ) See Nutrition Facts
  p.product-info__nutritional-disclaimer.body--xs(
    v-if="nutritionalDisclaimer"
    v-text="nutritionalDisclaimer"
  )
</template>

<script>
  export default {
    name: 'ProductInfo',
    props: {
      product: Object,
      variantTitle: String,
      price: String,
      comparePrice: String,
      nutritionalDisclaimer: String,
      nutritionFactsVisible: Boolean
    },
    computed: {},
    methods: {
      scrollToNutritionFacts() {
        let nutritionSection;
        if (this.$mq === 'mobile' || this.$mq === 'tablet') {
          nutritionSection = document.querySelector('[data-section="nutrition-facts-mobile"]').getBoundingClientRect();
        } else {
          nutritionSection = document.querySelector('[data-section="nutrition-facts"]').getBoundingClientRect();
        }
        const bodyRect = document.body.getBoundingClientRect();
        const offset = (nutritionSection.top - bodyRect.top) - 55;

        window.scrollTo({
          top: offset,
          behavior: 'smooth'
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  .product-info__price--compare {
    text-decoration: line-through;
  }

  .product-info__price--divider {
    margin: 0 rem(10px);
  }

</style>
